import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/24_road/24_road"
 * Contains 1 texture(s)
 */
export class Desktop24RoadAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/24_road/24_road';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '24_road.jpg'
    ] as const;
}
